import * as fromEntities from '../shared/entities';
//- Selectors
export const getUser = (state, userId) =>
  fromEntities.getEntity(state.entities.user, userId);
